// @flow
import { actionTypes as uiActionTypes } from 'catena/er2_ui'
import * as actionTypes from '../constants/action_types'

// [minx, miny, maxx, maxy]
export type ExtentType = {
    bbox_3857: [number, number, number, number],
    bbox_4326: [number, number, number, number]
}

export type ActionsType = {
}

export type ViewType = {
    center: Array<number>,
    resolution: number,
    rotation: number,
    extent: ExtentType,
    // Extend er2_map's ViewType to store the mapScale.
    mapScale: number,
}

export type MapType = {
    apiKeys: {},
    extent?: ExtentType,
    icons: {},
    mapView: ViewType,
    needsMapExtentUpdate: boolean,
    needsMapViewUpdate: boolean,
    showMapToolbar: boolean,
}

type MapActionType = {
    type: string,
    id: string,
    extent?: ExtentType,
    mapView?: ViewType,
    showMapToolbar?: boolean,
}

const initialMapView = {
    center: [0, 0],
    resolution: 0,
    rotation: 0,
    mapScale: 0,
}

export const initialState = {
    apiKeys: {},
    mapView: initialMapView,
    needsMapExtentUpdate: false,
    needsMapViewUpdate: false,
    showMapToolbar: true,
}

export default function map(state: MapType = initialState, action: MapActionType) {
    let newstate = state
    if (action.type === actionTypes.SET_FETCHED_STATE) {
        if (action.state.map) {
            newstate = {
                ...state,
                ...action.state.map,
            }
            if (action.state.map.mapView) {
                newstate.needsMapViewUpdate = true
            } else if (action.state.map.extent) {
                newstate.needsMapExtentUpdate = true
            }
        }
    } else if (action.type === actionTypes.CHANGE_MAPSCALE) {
        newstate = {
            ...state,
            mapView: { ...state.mapView, mapScale: action.mapScale },
        }
    } else if (action.type === uiActionTypes.GEO_BAR_FETCHED_OPERATION) {
        newstate = {
            ...state,
            needsStateRefresh: true,
        }
    } else if (action.type === actionTypes.SET_MAP_EXTENT) {
        newstate = {
            ...state,
            extent: action.extent,
            needsMapExtentUpdate: true,
        }
    } else if (action.type === actionTypes.SET_MAP_EXTENT_HANDLED) {
        newstate = {
            ...state,
            needsMapExtentUpdate: false,
        }
    } else if (action.type === actionTypes.SET_MAP_VIEW_HANDLED) {
        newstate = {
            ...state,
            needsMapViewUpdate: false,
        }
    } else if (action.type === actionTypes.SHOW_MAP_TOOLBAR) {
        newstate = {
            ...state,
            showMapToolbar: action.show,
        }
    } else if (action.type === actionTypes.UPDATE_MAP_VIEW) {
        newstate = {
            ...state,
            // Unset extent to prevent the map from trying to keep zooming to the extent.
            extent: null,
            mapView: action.mapView,
            needsMapViewUpdate: true,
        }
    }

    return newstate
}
